import { useTranslation } from 'react-i18next'
import React from 'react'
import { Text, View } from 'react-native'
import styles from '../../../styles'
import textStyles from '../../../styles/text'

function SICDTerm() {
  const { t } = useTranslation('faq')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="what-is-sicd-header">{t('whatIsSICD')}</Text>
      </View>
      <View>
        <Text style={textStyles.bodyContentText}>{t('sicdParagraph1')}</Text>
        <Text style={textStyles.bodyContentText}>{t('sicdParagraph2')}</Text>
        <Text style={[textStyles.h3, styles.shark_grey]}>{t('howItWorks')}</Text>
        <Text style={textStyles.bodyContentText}>{t('sicdParagraph3')}</Text>
        <Text style={[textStyles.h3, styles.shark_grey]}>{t('thingsToKnow')}</Text>
        <Text style={textStyles.bodyContentText}>{t('sicdParagraph4')}</Text>
      </View>
    </View>
  )
}

export default SICDTerm
